import { createFileRoute } from "@tanstack/react-router";
import { KontraktProducentRaportPage } from "@/features/contracts/kontrakt-producent-raport-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kontrakty/raporty/producent")({
	component: KontraktProducentRaportPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.raporty-producent",
			location.pathname,
		);
	},
});
